import { get, getTrackingString } from "../../utils/object-helpers";

static function removeProductCount(string) {
    return string.replace(/\([0-9^()]*\)/g, '').trim();
}

$ {
    const catModule = get(input, 'page.modules.STORE_CATEGORIES_MODULE', null);
    const buttonText = get(catModule, 'label', 'Shop by category');
}

<macro|{ category, index }| name="single-category">
    <li data-index=index class=`str-categories__single str-categories__${category._type}`>
        $ {
            const label = get(category, "label", {});
            const labelText = get(label, "textSpans.0.text", '');
            const action = get(category, "action", null);
            const url = get(action, "URL", '');
            const isAjax = get(action, "clientPresentationMetadata.ajax") === "true";
            const trackingData = getTrackingString(category, "action.trackingList");
            const accessibilityText = removeProductCount(get(label, "textSpans.0.text", ""));
            const subCatA11yText = get(category, 'showSubCategoriesAction.accessibilityText', '');
        }
        <div class="str-categories__single--current">
            <if(isAjax)>
                <str-textual-display
                    on-click("fetchCategoryListings", url)
                    ...label
                    tabindex="-1"
                    action=action
                    customParser=removeProductCount
                    accessibilityText=accessibilityText
                    class="str-categories__single--option"
                />
            </if>
            <else>
                <str-textual-display
                    ...label
                    tabindex="-1"
                    action=action
                    customParser=removeProductCount
                    accessibilityText=accessibilityText
                    class="str-categories__single--option"
                />
            </else>
            <if(category.categories)>
                <ebay-button
                    class="str-categories__toggle-collapse no-border"
                    data-has-children="true"
                    variant="icon"
                    tabindex="-1"
                    aria-label=subCatA11yText>
                    
                    <ebay-chevron-right-16-icon />
                </ebay-button>
            </if>
            <else>
                <ebay-chevron-right-16-icon class="str-categories__toggle-collapse str-categories__toggle-collapse--fake" />
            </else>
        </div>
        <if(category.categories)>
            <div class="str-categories__sub-list str-categories__level-wrapper">
                <ebay-button
                    aria-label=accessibilityText
                    class="str-categories__sub-toggle-collapse no-border"
                    data-is-parent="true"
                    variant="icon">

                    <ebay-chevron-left-16-icon />
                    <str-textual-display ...label customParser=removeProductCount />
                </ebay-button>
                <ul tabindex=`${state.open ? "0" : "-1"}` role="list">
                    <for|subCategory, idx| of=category.categories>
                        <single-category category=subCategory index=idx />
                    </for>
                </ul>
            </div>
        </if>
    </li>
</macro>

<section class=`str-categories__wrapper ${state.open ? "str-categories__wrapper--open" : ""}`>
    <div class="str-categories__wrapper-container">
        <div class=`str-categories ${state.focusDisabled ? "str-categories--focus-disabled" : ""}`>
            $ {
                const back = get(catModule, "back", {});
                const header = get(catModule, "header", {});
                const categories = get(catModule, "categories", []);
                const labelText = get(catModule, "header.textSpans.0.text", '');
                const url = get(catModule, "header.action.URL", '');
                const trackingData = getTrackingString(catModule, "header.action.trackingList");
                const isAjax = get(catModule, "header.action.clientPresentationMetadata.ajax") === "true";
            }
            <div class="str-categories__back">
                <ebay-button
                    class="no-border"
                    variant="icon"
                    on-click("closeCategories")>

                    <ebay-arrow-left-16-icon />
                </ebay-button>
                <h3>${buttonText}</h3>
            </div>
            $ {
                const info = get(input, 'page.modules.PRESENCE_INFORMATION_MODULE', null);
                const storeName = get(info, 'displayName.textSpans', []);
                const storeNameLink = get(info, 'displayName.action.URL', '');
                const storeNameTracking = getTrackingString(info, 'displayName.action.trackingList');
                const logoTitle = get(info, 'logo.title', '');
                const logoUrl = get(info, 'logo.URL', '');
                const logoLink = get(info, 'logo.action.URL', '');
                const logoA11y = get(info, 'logo.action.accessibilityText', '');
                const logoTracking = getTrackingString(info, 'logo.action.trackingList');
            }
            <div class="str-categories__layer-header">
                <div class="str-categories__store-logo">
                    <a href=logoLink data-track=logoTracking aria-label=logoA11y>
                        <img src=logoUrl/>
                    </a>
                </div>
                <div class="str-categories__store-name">
                    <a href=storeNameLink data-track=storeNameTracking>
                        <str-text-span textSpans=storeName />
                    </a>
                </div>
            </div>
            <div class="str-categories__small-wrapper str-categories__level-wrapper">
                <div class="str-categories__header">
                    <if(isAjax)>
                        <str-textual-display on-click("fetchCategoryListings", url) class="str-categories__root-category" data-is-parent="true" ...header />
                    </if>
                    <else>
                        <str-textual-display class="str-categories__root-category" data-is-parent="true" ...header />
                    </else>
                    <ebay-chevron-right-16-icon class="str-categories__toggle-collapse str-categories__toggle-collapse--fake" />
                </div>
                <ul class="str-categories__list" tabindex=`${state.open ? "0" : "-1"}` role="list">
                    <for|category, idx| of=categories>
                        <single-category category=category index=idx />
                    </for>
                </ul>
            </div>
        </div>
    </div>
</section>
